export default __webpack_public_path__ + "static/media/jinrong.a16fe1b3.png";